import CONSTANTS from '../constants';

export const APP_SCHEME = {
    NN: 'ftnn://',
    MM: 'ftmm://'
};

export const WEB_HOST = {
    FUTU: 'https://q.futunn.com',
    MOO: 'https://www.moomoo.com'
};

export const PATH = {
    COMMUNITY_DISCUSSION: '/community/discussion/',
    COMMUNITY_FEED: '/community/feed/',
    STOCK: '/stock/',
    NNCIRCLE_DISCUSSION: 'nncircle/discussion/',
    NNCIRCLE_FEED: 'nncircle/feed/',
    QUOTE_STOCK_DETAIL: 'quote/stockDetail/'
};

export function genAppDiscussionLink(discussionId) {
    const isMoo = CONSTANTS.isMoo;
    const scheme = isMoo ? APP_SCHEME.NN : APP_SCHEME.MM;
    return `${scheme}${PATH.NNCIRCLE_DISCUSSION}${discussionId}`;
}

export function genWebDiscussionLink(lang, discussionId) {
    const isMoo = CONSTANTS.isMoo;
    const base = isMoo ? WEB_HOST.MOO : WEB_HOST.FUTU;
    let link = `${base}${PATH.COMMUNITY_DISCUSSION}${discussionId}?lang=${lang}`;
    if (lang === 'ja' && isMoo) {
        link = `${WEB_HOST.MOO}/ja${PATH.COMMUNITY_DISCUSSION}${discussionId}?lang=${lang}`;
    }
    return link;
}

export function genAppFeedLink(feedId) {
    const isMoo = CONSTANTS.isMoo;
    const scheme = isMoo ? APP_SCHEME.MM : APP_SCHEME.NN;
    return `${scheme}${PATH.NNCIRCLE_FEED}${feedId}`;
}

export function genWebFeedLink(lang, feedId) {
    const isMoo = CONSTANTS.isMoo;
    const base = isMoo ? WEB_HOST.MOO : WEB_HOST.FUTU;
    let link = `${base}${PATH.COMMUNITY_FEED}${feedId}?lang=${lang}`;
    if (lang === 'ja' && isMoo) {
        link = `${WEB_HOST.MOO}/ja${PATH.COMMUNITY_FEED}${feedId}?lang=${lang}`;
    }
    return link;
}

export function genAppStockLink(stockId) {
    const isMoo = CONSTANTS.isMoo;
    const scheme = isMoo ? APP_SCHEME.MM : APP_SCHEME.NN;
    return `${scheme}${PATH.QUOTE_STOCK_DETAIL}${stockId}/1/1`;
}

export function genWebStockLink(lang, stockSymbol) {
    const isMoo = CONSTANTS.isMoo;
    const symbol = stockSymbol.replace(/\./g, '-');
    if (isMoo) {
        if (lang === 'ja') {
            return `${WEB_HOST.MOO}/ja${PATH.STOCK}${symbol}?lang=${lang}`;
        }
        return `${WEB_HOST.MOO}${PATH.STOCK}${symbol}?lang=${lang}`;
    }
    return `https://www.futunn.com/stock/${symbol}?lang=${lang}`;
}

export function genDiscussionLink(discussionId, lang) {
    if (CONSTANTS.isMobileNN) {
        return genAppDiscussionLink(discussionId);
    }
    return genWebDiscussionLink(lang, discussionId);
}

export function genFeedLink(feedId, lang) {
    if (CONSTANTS.isMobileNN) {
        return genAppFeedLink(feedId);
    }
    return genWebFeedLink(lang, feedId);
}

export function genStockLink(stock, lang) {
    if (CONSTANTS.isMobileNN) {
        return genAppStockLink(stock.id);
    }
    return genWebStockLink(lang, stock.symbol);
}
